<template>
  <div class="col-12 connections py-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Договоры лизинга</h5>
      </div>
      <div class="card-body">
        <div class="leasing-placeholder">
          <p class="mb-2">Данные по договорам лизинга пока не подключены к отдельному источнику.</p>
          <p class="mb-0 text-muted">
            После выбора и интеграции источника этот раздел можно реализовать по тому же шаблону, что контракты,
            проверки и исполнительные производства.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Leasing',
  });
</script>
<style scoped lang="scss">
  .leasing-placeholder {
    padding: 1.25rem;
    background: #f4f6fa;
    border-radius: 14px;
  }
</style>
